import axios from "axios";
import configuration from "../configuration/configuration";
import encodeDataToURL from "../components/Akitatek/encodeDatatoURL";

/** Appels de l'assistant de création d'une prise en charge (voir PriseEnChargeAssistantController côté API). */
export default class PriseEnChargeAssistantAPI {

    async chercherClients(search) {
        const response = await axios.get(`${configuration.API}/api/priseencharge/assistant/clients?` + encodeDataToURL({search}));
        return response.data?.datas ?? [];
    }

    async client(id) {
        const response = await axios.get(`${configuration.API}/api/find/user/${id}`);
        return response.data;
    }

    async chercherAppareils(search) {
        const response = await axios.get(`${configuration.API}/api/priseencharge/assistant/appareils?` + encodeDataToURL({search}));
        return response.data?.datas ?? [];
    }

    async appareil(id) {
        const response = await axios.get(`${configuration.API}/api/priseencharge/assistant/appareils?` + encodeDataToURL({id}));
        return response.data?.datas?.[0] ?? null;
    }

    async marques(search = "") {
        const response = await axios.get(`${configuration.API}/api/annuaire/marques?` + encodeDataToURL({search}));
        return response.data?.datas ?? [];
    }

    async creerAppareil(data) {
        const response = await axios.post(`${configuration.API}/api/priseencharge/assistant/appareil`, data);
        return response.data?.datas;
    }

    async creerPrestation(data) {
        const response = await axios.post(`${configuration.API}/api/priseencharge/assistant/prestation`, data);
        return response.data?.datas;
    }

    async enregistrer(data) {
        const response = await axios.post(`${configuration.API}/api/priseencharge/assistant`, data);
        return response.data?.datas;
    }
}
